import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('user.shared-accounts', {
        url: '/sharedaccounts',
        views: {
            '': 'userSharedAccounts',
            'header@user': 'userSharedAccountsHeader',
        },
        resolve: {sharedAccounts},
    })
}

/** @ngInject */
function sharedAccounts($filter, UsersSharedAccountService) {
    return UsersSharedAccountService.usersCompanySharedAccounts.query().$promise
        .then(items => $filter('orderBy')(items, 'publicService.serviceName'))
}



// WEBPACK FOOTER //
// ./src/portal/states/user/users-shared-accounts/users-shared-accounts.state.js